/*
 * @Author: weiShu
 * @Date: 2025-12-29 15:40:44
 * @LastEditors: weiShu
 * @LastEditTime: 2026-01-05 09:34:03
 * @FilePath: \health-commission-new\src\api\index.js
 * @Description: 
 */
import request from '@/utils/server.js'


export function userLogin(data) {
    return request({
        url: `/user/login`,
        method: 'post',
        data: data
    })
}

export function loginByToken(token) {
    return request({
        url: `/user/loginByToken`,
        method: 'get',
        params: {
            token: token
        }
    })
}

export function userRegister(data) {
    return request({
        url: `/user/register`,
        method: 'post',
        data: data
    })
}

export function getCaptcha() {
    return request({
        url: `/user/getCaptcha`,
        method: 'get'
    })
}

export function forgotPassword(data) {
    return request({
        url: `/user/forgotPassword`,
        method: 'post',
        data: data
    })
}

export function getRegisterAgreement() {
    return request({
        url: `/h5-config/getRegisterAgreement`,
        method: 'get'
    })
}

export function getLoginInfo() {
    return request({
        url: `/user/loginInfo`,
        method: 'get'
    })
}

export function getMyToBeTested(data) {
    return request({
        url: `/exam/getMyToBeTested`,
        method: 'post',
        data: data
    })
}

export function getTopics(testPaperId) {
    return request({
        url: `/exam/getTopics/${testPaperId}`,
        method: 'get'
    })
}

export function getAnsweredRecords(answerId) {
    return request({
        url: `/exam/getAnsweredRecords/${answerId}`,
        method: 'get'
    })
}

export function submitAnswer(data) {
    return request({
        url: `/exam/answer`,
        method: 'post',
        data: data
    })
}

export function uploadImage(file) {
    return request({
        url: `/upload/uploadImage`,
        method: 'post',
        formData: {
            file: file
        }
    })
}

export function submitExam(data) {
    return request({
        url: `/exam/theResponding`,
        method: 'post',
        data: data
    })
}

export function getMyAnswers(data) {
    return request({
        url: `/exam/getMyAnswers`,
        method: 'post',
        data: data
    })
}

export function startQuiz(testPaperId) {
    return request({
        url: `/exam/startQuiz/${testPaperId}`,
        method: 'get'
    })
}

export function getCertificateInfo(answerId) {
    return request({
        url: `/exam/getCertificateInfo/${answerId}`,
        method: 'get'
    })
}

export function getTrainList() {
    return request({
        url: `/exam/getTrainList`,
        method: 'get'
    })
}

export function editorUser(data) {
    return request({
        url: `/exam/editorUser`,
        method: 'post',
        data: data
    })
}

export function getCertificate(answerId) {
    return request({
        url: `/exam/getCertificate/${answerId}`,
        method: 'get'
    })
}

export function getTestPaperInfo(answerId) {
    return request({
        url: `/exam/getTestPaperInfo/${answerId}`,
        method: 'get'
    })
}

